/**
 * @summary     app.exo.js
 * @description App JS EXO Controller
 * @version     1.0
 	> 1.0 Initial version
		- 02/02/2017 SG
 * @author      Silas Garrison (http://silasgarrison.com/)
 ** EXAMPLES:
 ** NOTE:
 	This is an exo backend controller that allows for easy integration with exo API's
 ** TODO:
*/

app.addFeature(
	"exo",
	function(){
		"use strict";

		var self = this;

		/*
			Name: init
			Use: API.init()
			Args: none
			Description: initialization
		*/
		self.init = function(){

		};

		/*
			Name: apiCall
			Use: PRIVATE.apiCall()
			Args: action String - The operation (read, write, etc.) to run on the server
					dataObjectName String - The database target
					data Object - Hashmap of query parameters on read operations, values to write/update on write operations
					query Object - Hashmap of parameters to filter values on for update operations
					options Object - Hashmap of parameters such as limit to apply to certain read operations
					token String - Session token string
					doCache Boolean - If true, it will cache the request and use cacheing mechanisms when making the http request. Default is false|undefined
			Description: The API call which is a ajax call with extra options added for processing
		*/
		function apiCall(action, dataObjectName, data, query, options, token, doCache){
			var def = app.deferred(),
				args = {
					task : action,
					dataObjectName : dataObjectName,
					data : data || {}
				};

			/*
				NOTE:
					If a token is available in the dataStore, get it
			*/
			if(token || app.dataStore.get("session.token") !== null){
				args.token = token || app.dataStore.get("session.token");
			}
			/*
				NOTE:
					Add query if present
			*/
			if(query){
				args.query = query;
			}
			/*
				NOTE:
					Add options if present
			*/
			if(options){
				args.options = options;
			}

			/*
				Step:
					Make the request to the server
			*/
			def.step(
				function(){
					var ajaxArgs = {
						url : app.config.apiURL,
						contentType: "application/json",
						responseType : "json",
						success : def.next,
						error : def.next,
						args : args
					};

					if(doCache){
						ajaxArgs.args.dataStr = JSON.stringify(args);
						ajaxArgs.cacheLife = app.static.min * 1.5;
						ajaxArgs.cacheKeys = ['dataStr'];
						ajaxArgs.cacheScope = 'session';
					}

					app.ajax.request(ajaxArgs);
				}
			);

			/*
				Step:
					Return the results - different for types of operations (reads vs writes)
			*/
			def.step(
				function(res){
					if(res.responseJson){
						def.results(res.responseJson).next();
					}
					else {
						def.results({error : true, msg : 'Unknown transmission error'}).next();
					}
				}
			);

			return def.begin();
		}

		/*
			Name: read
			Use: API.read()
			Args: dataObjectName String - Name of targetted data object
					data Object - Hashmap of query properties
					token String - Optional session token
					doCache Boolean - If true, it will cache the request and use cacheing mechanisms when making the http request. Default is false|undefined
			Description: Read all records
		*/
		self.read = function(dataObjectName, data, token, doCache){
			return apiCall(
				"read",
				dataObjectName,
				data,
				null,
				null,
				token,
				doCache
			);
		};

		/*
			Name: count
			Use: API.read()
			Args: dataObjectName String - Name of targetted data object
					data Object - Hashmap of query properties
					token String - Optional session token
					doCache Boolean - If true, it will cache the request and use cacheing mechanisms when making the http request. Default is false|undefined
			Description: counts records
		*/
		self.count = function(dataObjectName, data, token, doCache){
			return apiCall(
				"count",
				dataObjectName,
				data,
				null,
				null,
				token,
				doCache
			);
		};

		/*
			Name: readOne
			Use: API.readOne()
			Args: dataObjectName String - Name of targetted data object
					data Object - Hashmap of query properties
					token String - Optional session token
					doCache Boolean - If true, it will cache the request and use cacheing mechanisms when making the http request. Default is false|undefined
			Description: Read one record
		*/
		self.readOne = function(dataObjectName, data, token, doCache){
			return apiCall(
				"readOne",
				dataObjectName,
				data,
				null,
				null,
				token,
				doCache
			);
		};


		self.readJoinBackend = function(dataObjectName, data, options, token, doCache) {
			return apiCall(
				"readJoin",
				dataObjectName,
				data,
				null,
				null,
				token,
				doCache
			);
		};

		/*
			Name: readMany
			Use: API.readMany()
			Args: dataObjectName String - Name of targetted data object
					data Object - Hashmap of query properties
					options Object - Hashmap of options such as limit
					token String - Optional session token
					doCache Boolean - If true, it will cache the request and use cacheing mechanisms when making the http request. Default is false|undefined
			Description: Read many records with optional parameters such as limit
		*/
		self.readMany = function(dataObjectName, data, options, token, doCache){
			return apiCall(
				"readMany",
				dataObjectName,
				data,
				null,
				options,
				token,
				doCache
			);
		};

		/*
			Name: distinct
			Use: API.distinct()
			Args: dataObjectName String - Name of targetted data object
					data Object - Hashmap of query properties
					token String - Optional session token
					doCache Boolean - If true, it will cache the request and use cacheing mechanisms when making the http request. Default is false|undefined
			Description: Gets a distinct list of values
		*/
		self.distinct = function(dataObjectName, data, token, doCache){
			return apiCall(
				"distinct",
				dataObjectName,
				data,
				null,
				null,
				token,
				doCache
			);
		};

		/*
			Name: write
			Use: API.write()
			Args: dataObjectName String - Name of targetted data object
					data Object - Hashmap of query properties
					token String - Optional session token
			Description: Writes a new record
		*/
		self.write = function(dataObjectName,data,token){
			return apiCall(
				"write",
				dataObjectName,
				data,
				null,
				null,
				token
			);
		};

		/*
			Name: update
			Use: API.update()
			Args: dataObjectName String - Name of targetted data object
					data Object - Hashmap of field properties
					query Object - Hashmap of query properties
					token String - Optional session token
			Description: Updates a record
		*/
		self.update = function(dataObjectName,data,query,token){
			return apiCall(
				"update",
				dataObjectName,
				data,
				query,
				null,
				token
			);
		};

		/*
			Name: delete
			Use: API.delete()
			Args: dataObjectName String - Name of targetted data object
					data Object - Hashmap of field properties
					query Object - Hashmap of query properties
					token String - Optional session token
			Description: Deletes a record
		*/
		self.delete = function(dataObjectName,data,query,token){
			return apiCall(
				"delete",
				dataObjectName,
				data,
				query,
				null,
				token
			);
		};

		/*
			Name: exists
			Use: API.exists()
			Args: dataObjectName String - Name of targetted data object
					data Object - Hashmap of query properties
					token String - Optional session token
			Description: Determines if a record exists
		*/
		self.exists = function(dataObjectName,data,token){
			return apiCall(
				"exists",
				dataObjectName,
				data,
				null,
				null,
				token
			);
		};

		/*
			Name: updateOrWrite
			Use: API.updateOrWrite()
			Args: dataObjectName String - Name of targetted data object
					data Object - Hashmap of query properties
					token String - Optional session token
			Description: TBD
		*/
		self.updateOrWrite = function(dataObjectName,data,token){
			return apiCall(
				"updateOrWrite",
				dataObjectName,
				data,
				null,
				null,
				token
			);
		};

		/*
			Name: findAndModify
			Use: API.findAndModify()
			Args: dataObjectName String - Name of targetted data object
					data Object - Hashmap of query properties
					token String - Optional session token
			Description: TBD
		*/
		self.findAndModify = function(dataObjectName, data, token){
			return apiCall(
				"findAndModify",
				dataObjectName,
				data,
				null,
				null,
				token
			);
		};

		/*
			Name: readJoin
			Use: PRIVATE.readJoin()
			Args: join Object - Hashmap defining the join parameters
					dataStore Object - Hashmaps of data sets
					token String - Optional session token
					doCache Boolean - If true, it will cache the request and use cacheing mechanisms when making the http request. Default is false|undefined
			Description: Reads the join query and binds it to the original data set
		*/
		function readJoin(join, dataStore, token, doCache){
			var readJoinDef = app.deferred(9999),
				$in = [],
				joinSrc = join.on.from.src,
				joinCol = join.on.from.to,
				indexes = {};

			/*
				NOTE:
					Ensure there's a data (aka query) object available
			*/
			join.data = join.data || {};

			/*
				NOTE:
					Iterate through the source/parent data and build a unique query/WHERE clause
			*/
			(dataStore[joinSrc] || []).forEach(
				function(row,idx){
					/*
						NOTE:
							Build out indexes so we don't have to iterate through every record
					*/
					if(!indexes[row[joinCol]]){
						indexes[row[joinCol]] = [];
					}
					indexes[row[joinCol]].push(idx);

					$in.push(row[joinCol]);
				}
			);

			/*
				NOTE:
					Add the $in[] clause to the data object
			*/
			join.data[join.on.to] = {
				$in : $in
			};

			/*
				NOTE:
					Go ahead and call the API read operation. Once it returns we'll bind the resulting data back to the result set then find and execute any further joins
			*/
			apiCall(
				"read",
				join.dataObjectName,
				join.data,
				null,
				null,
				token,
				doCache
			).finished(
				function(res){
					dataStore[join.dataObjectName] = res || [];
					/*
						NOTE:
							Bind the data back to it's source/parent data
					*/
					dataStore[join.dataObjectName].forEach(
						function(row){
							if(indexes[row[join.on.to]]){
								indexes[row[join.on.to]].forEach(
									function(idx){
										/*
											NOTE:
												Does the matching bind record already contain an array of records with the same name? Append it
										*/
										if(Array.isArray(dataStore[joinSrc][idx][join.dataObjectName])){
											dataStore[joinSrc][idx][join.dataObjectName].push(row);
										}
										/*
											NOTE:
												Does the matching bind record already contain a single record? Turn it into an array
										*/
										else if(dataStore[joinSrc][idx][join.dataObjectName]){
											dataStore[joinSrc][idx][join.dataObjectName] = [dataStore[joinSrc][idx][join.dataObjectName]];
											dataStore[joinSrc][idx][join.dataObjectName].push(row);
										}
										/*
											NOTE:
												Bind this record as an attribute to the matching source
										*/
										else {
											dataStore[joinSrc][idx][join.dataObjectName] = row;
										}
									}
								);
							}
						}
					);
					/*
						NOTE:
							Introspectively call the readJoin method for each join that has another join
					*/
					if(join.joins && join.joins.length > 0){
						join.joins.forEach(
							function(lclJoin,idx){
								/*
									NOTE:
										Each join that finishes should be checked if it's the last one - if so, end this readJoin instance
								*/
								readJoin(lclJoin, dataStore, token, doCache).finished(
									function(){
										if(join.joins.length === idx + 1){
											readJoinDef.end();
										}
									}
								);
							}
						);
					}
					/*
						NOTE:
							No additional joins just means this is done
					*/
					else {
						readJoinDef.end();
					}
				}
			);

			return readJoinDef;
		}

		/*
			Name: readJoin
			Use: API.readJoin()
			Args: queryObj Object - Hashmap defining each query with join parameters nested down to define joins
					token String - Optional session token
					doCache Boolean - If true, it will cache the request and use cacheing mechanisms when making the http request. Default is false|undefined
			Description: Reads and joins data together based upon loosely correlated keys
		*/
		self.readJoin = function(queryObj, token, doCache){
			var def = app.deferred(),
				dataStore = {};

			/*
				Step:
					Get the primary data set
			*/
			def.step(
				function(){
					apiCall(
						"read",
						queryObj.dataObjectName,
						queryObj.data,
						null,
						null,
						token,
						doCache
					).finished(
						function(res){
							dataStore[queryObj.dataObjectName] = res || [];
							def.next();
						}
					);
				}
			);

			/*
				Step:
					Iterate through joins and call the readJoin() method
			*/
			def.step(
				function(){
					var joinDef = app.deferred();

					if(dataStore[queryObj.dataObjectName].length === 0){
						def.next();
						return;
					}

					/*
						NOTE:
							Build steps for each join and once each join builder is finished, move to the next
					*/
					queryObj.joins.forEach(
						function(join){
							joinDef.step(
								function(){
									readJoin(join, dataStore, token, doCache).finished(
										joinDef.next
									);
								}
							);
						}
					);

					/*
						NOTE:
							Have this arbitrary step here so the process above doesn't move on too soon
					*/
					joinDef.step(
						function(){
							def.next();
						}
					);

					/*
						NOTE:
							Once all the above is done, move on
					*/
					joinDef.begin().finished(
						def.next
					);
				}
			);

			/*
				Step:
					Last of all, just make sure the result set is available and end the process
			*/
			def.step(
				function(){
					def.results(dataStore[queryObj.dataObjectName]).next();
				}
			);

			return def.begin();
		};

		return self;
	}
);
